import script from "./NuevoAlumno.vue?vue&type=script&setup=true&lang=js"
export * from "./NuevoAlumno.vue?vue&type=script&setup=true&lang=js"

import "./NuevoAlumno.vue?vue&type=style&index=0&id=3eef2886&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eef2886"]])

export default __exports__